var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3198 20.2972C41.3039 20.2972 39.9583 20.2748 38.283 20.2748C34.1971 20.2748 30.8375 16.893 30.8375 12.7687V5.53275C30.8375 4.9635 30.383 4.5 29.8193 4.5H17.9182C12.3641 4.5 7.875 9.0585 7.875 14.6452V38.889C7.875 44.7503 12.578 49.5 18.3816 49.5H36.1041C41.6381 49.5 46.125 44.9707 46.125 39.3795V21.3097C46.125 20.7383 45.6727 20.277 45.1069 20.2792C44.1556 20.286 43.0149 20.2972 42.3198 20.2972Z",
    fill: "url(#paint0_linear_3359_23130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.189 5.77658C35.5163 5.07683 34.3418 5.55833 34.3418 6.52808V12.4613C34.3418 14.9498 36.3915 16.9973 38.88 16.9973C40.4483 17.0153 42.6263 17.0198 44.4758 17.0153C45.4231 17.0131 45.9046 15.8813 45.2476 15.1973C42.8738 12.7291 38.6235 8.30558 36.189 5.77658Z",
    fill: "url(#paint1_linear_3359_23130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4403 33.5089C33.3651 33.5089 34.1166 34.2604 34.1166 35.1852C34.1166 36.1099 33.3651 36.8592 32.4403 36.8592H20.1913C19.2666 36.8592 18.5173 36.1099 18.5173 35.1852C18.5173 34.2604 19.2666 33.5089 20.1913 33.5089H32.4403ZM27.8073 22.272C28.7321 22.272 29.4836 23.0235 29.4836 23.9482C29.4836 24.873 28.7321 25.6222 27.8073 25.6222H20.1911C19.2663 25.6222 18.5171 24.873 18.5171 23.9482C18.5171 23.0235 19.2663 22.272 20.1911 22.272H27.8073Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3359_23130",
    x1: 27,
    y1: 4.5,
    x2: 27,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3359_23130",
    x1: 39.9462,
    y1: 5.44482,
    x2: 39.9462,
    y2: 17.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.ad7c8da76000d6e583e88f4262fe0790.svg";
export { ForwardRef as ReactComponent };